import React, { useState } from 'react';
import { useDecoratedStorage } from '../../services/Firestore/Resources';
import { NoneOwnerType } from '../../constants';
import withStyles from 'react-jss';
import StorageEditForm from './StorageEditForm';
import Modal from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';
import { Icon } from '../../components/Icon/Icon';
import Confirmation from '../../components/Confirmation/Confirmation';
import Api from '../../services/Api/Api';
import { useLoading } from '../../services/LoadingContext/LoadingContext';
import { withRouter } from 'react-router-dom';
import { useErrorHandler } from '../../services/Utils/useErrorHandler';
import StorageView from './StorageView';

const styles = {
  address: {
    whiteSpace: 'pre-wrap',
  },
};

const StoragePage = ({ classes, history, storageId }) => {
  const [storage, storageLoading] = useDecoratedStorage(storageId);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const errorHandler = useErrorHandler();

  const handleDelete = useLoading(async () => {
    try {
      await Api.DeleteStorage(storage);
      history.push('/storages/' + storage.parent);
    } catch (e) {
      await errorHandler(e);
    } finally {
      setShowDelete(false);
    }
  });
  if (storageLoading) return 'Loading...';
  if (!storage) return 'Storage not found';
  return (
    <>
      <div>
        <div style={{ float: 'right' }}>
          {storage.ownerType === NoneOwnerType && (
            <>
              <Button
                onClick={() => setShowEdit(true)}
                circle
                title={'Edit ' + storage.name + ' storage'}
              >
                <Icon>edit</Icon>
              </Button>
              <Button
                onClick={() => setShowDelete(true)}
                circle
                title={'Delete ' + storage.name + ' storage'}
              >
                <Icon>delete</Icon>
              </Button>
            </>
          )}
        </div>
        <h2>Storages:</h2>
      </div>
      {storage.ownerType === 5 && storage.parent === '' && (
        <div>This storage is an asset which is in transit</div>
      )}
      <StorageView storage={storage} />
      {showEdit && (
        <Modal open={showEdit} onClose={() => setShowEdit(false)}>
          <StorageEditForm storage={storage} onSubmit={() => setShowEdit(false)} />
        </Modal>
      )}
      <Confirmation
        open={showDelete}
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      >
        <p>Do you really want to delete the storage: {storage.name}</p>
      </Confirmation>
    </>
  );
};

export default withRouter(withStyles(styles)(StoragePage));
